import { Text } from '@wartek-id/text'

import { formatNumber } from '@/utils/string'
import { SatDikDetail } from '@/apis/types'

import { KeyValTable } from '@/components/KeyValTable'

type Props = {
  data?: SatDikDetail
}

// eslint-disable-next-line unused-imports/no-unused-vars
export function TabSaranaPrasarana({ data }: Props) {
  return (
    <KeyValTable
      rows={[
        {
          key: 'name',
          displayName: 'Luas Tanah',
          value: data?.luasTanahMilik
            ? `${formatNumber(data?.luasTanahMilik)}` || ''
            : '',
          CustomValueComponent: ({ value }) => {
            return (
              <Text>
                {value} m<sup>2</sup>
              </Text>
            )
          },
        },
        {
          key: 'internet',
          displayName: 'Akses Internet',
          value: data?.aksesInternet || '-',
        },
        {
          key: 'sumber-listrik',
          displayName: 'Sumber Listrik',
          value: data?.sumberListrik || '-',
        },
      ]}
    />
  )
}
